export default "__VITE_ASSET__DrCr6Kyn__"